/**
 * Converts a string from dash-case to camelCase.
 *
 * @param {string} subject - The string to convert.
 * @returns {string} The camelCase representation of the string.
 */
export function dashToCamelCase(subject) {
    return subject
        .split('-')
        .map((part, index) => index === 0 ? part : part.charAt(0).toUpperCase() + part.slice(1))
        .join('');
}

/**
 * Converts a title to camel case.
 *
 * @param {string} subject - The string to convert.
 * @returns {string} The camel case representation of the title.
 */
export function titleToCamelCase(subject) {
    return subject.charAt(0).toLowerCase() + subject.slice(1);
}

/**
 * Converts a string to title case.
 *
 * @param {string} subject - The string to convert.
 * @returns {string} The title case representation of the string.
 */
export function toTitleCase(subject) {
    return subject.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

/**
 * Resolves the appropriate word form based on the count.
 *
 * @param {number} count - The count to determine the word form for.
 * @param {string} singularForm - The singular form of the word.
 * @param {string} pluralForm - The plural form of the word.
 * @returns {string} The appropriate word form based on the count.
 */
export function resolveWord(count, singularForm, pluralForm) {
    return count > 0 && count <= 1 ? singularForm : pluralForm;
}
